import React, { useState } from 'react';
import { Button, Dropdown } from 'antd';
import { AudioTwoTone, CloudUploadOutlined, DownOutlined, AudioOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import RecordingModal from './RecordingModal';
import AudioUploadModal from './AudioUploadModal';

export default function NewSessionButton({ patient = null, fromPatientDetails = false }) {
  const { t } = useTranslation();
  const [isUploadModalVisible, setIsUploadModalVisible] = useState(false);
  const [isRecordingModalVisible, setIsRecordingModalVisible] = useState(false);

  const handleMenuClick = ({ key }) => {
    if (key === 'record') {
      setIsRecordingModalVisible(true);
    } else if (key === 'upload') {
      setIsUploadModalVisible(true);
    }
  };

  const items = [
    {
      key: 'record',
      label: (
        <div data-testid="dropdown-option-record" style={{ fontSize: '16px' }}>
          <AudioTwoTone style={{ marginRight: '10px', fontSize: '16px' }} />
          {t('session_recorder.fields.live_session')}
        </div>
      ),
    },
    {
      key: 'upload',
      label: (
        <div data-testid="dropdown-option-upload" style={{ fontSize: '16px' }}>
          <CloudUploadOutlined style={{ marginRight: '10px', fontSize: '16px', color: '#1890ff' }} />
          {t('session_recorder.fields.upload_audio')}
        </div>
      ),
    },
  ];

  if (patient) {
    return (
      <>
        <Button
          icon={<AudioOutlined />}
          data-testid='new-session-with-patient-button'
          onClick={() => setIsRecordingModalVisible(true)}
        >
          {t('session_recorder.fields.start')}
        </Button>
        <RecordingModal
          open={isRecordingModalVisible}
          onClose={() => setIsRecordingModalVisible(false)}
          patient={patient}
          fromPatientDetails={fromPatientDetails}
        />
      </>
    );
  }

  return (
    <>
      <Dropdown
        menu={{
          items,
          onClick: handleMenuClick,
        }}
        trigger={['hover']}
      >
        <Button
          type="primary"
          shape="round"
          size="large"
          data-testid="new-session-button"
          style={{ minWidth: '200px' }}
        >
          {t('session_recorder.fields.new_session')} <DownOutlined />
        </Button>
      </Dropdown>

      <AudioUploadModal
        open={isUploadModalVisible}
        onClose={() => setIsUploadModalVisible(false)}
      />

      <RecordingModal
        open={isRecordingModalVisible}
        onClose={() => setIsRecordingModalVisible(false)}
      />
    </>
  );
}